export default {
    /**
     * Removes Support User from given array
     *
     * @param {any[]} list
     * @returns
     */
    _removeSupportUserFromList(list: any[]) {
        for (let index = 0; index < list.length; index++) {
            if (list[index].familyName === 'Support' && list[index].firstName === 'STARFACE UP') {
                list.splice(index, 1);
            }
        }
    },

    /**
     * Removes Support User from assignable users array
     *
     * @param {any[]} list
     * @returns
     */
    _removeSupportUserFromAssignableUsersList(list: any[]) {
        for (let index = 0; index < list.length; index++) {
            if (list[index].lastname === 'Support' && list[index].firstname === 'STARFACE UP') {
                list.splice(index, 1);
            }
        }
    },
};
